import React from 'react'

import FormPage from '../FormPage'
import {useNavigate} from "react-router-dom";

class AuthDeactivateAccount extends FormPage
{
    static path = '/account/deactivate';

    /**
     * The css class for the page container
     *
     * @var {String}
     */
    static BGClass = 'bordered-panel auth-settings-form';

    /**
     * The title shown on the form
     */
    static FormTitle = "auth.deactivate.title";

    /**
     * The subtitle shown on the form
     */
    static FormSubtitle = "auth.deactivate.subtitle";

    /**
     * The submit button title for the form
     */
    static FormSubmit = false;

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800;

    /**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
        super(props);

        this.state = {
            ...this.state,
            model: {}
        };
    }

    /**
     * Renders form child elements
     *
     * @returns {Component}
     */
    renderFormChildren()
    {
        return (
            <div className='mx-auto'>
                <p className={"mt-4"}>
                    {TB.tryTrans('auth.deactivate.info')}
                </p>

                <div className="form-footer">
                    <div className="form-buttons">
                        <button type="button"
                            formNoValidate
                            className="btn-submit btn btn-primary"
                            onClick={this.onSubmit.bind(this)}>
                            {TB.tryTrans('auth.deactivate.submit_button')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Overridable method for handling form submit button clicks when form is valid
     *
     * @param {Object} model
     * @returns void
     */
    async onSubmit(model)
    {
        let didConfirm = await TB.sysAlert(
            'talent.deactivate_account'
        );

        if (!didConfirm) {
            return;
        }

        let didDeactivate = await TB.auth().deactivateAccount();

        this.props.navigate(TB.auth().appropriate(), {replace: true})
    }
}

const DeactivateAccount = (props) => {
    const navigate = useNavigate();

    return (
        <AuthDeactivateAccount navigate={navigate}/>
    )
}

export default DeactivateAccount;